import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prada-ping',
  templateUrl: './ping.component.html',
  styleUrls: ['./ping.component.scss'],
})
export class PingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
